<template>
  <div class="wrapper">
    <Header class="black"></Header>

    <div class="main">
      <div class="pagebg" :style="{backgroundImage: 'url(' + newbg + ')'}">
        <div class="container">
          <a class="btn" v-if="isme" @click="modal = true"><i class="icon"></i> 换背景</a>
        </div>
      </div>

      <div class="auth-box">
        <div class="container">
          <div class="master-info clearfix" v-if="produceInfo">
            <div class="master-mask l">
              <img :src="produceInfo.faceUrl" style="width: 100%; height: 100%;"/>
            </div>
            <div class="master-vitae r">
              <div class="vitae-head clearfix">
                <div class="name">{{produceInfo.nickName}}</div>
                <ul class="tag clearfix">
                  <li v-if="produceInfo.tagStatus == 3||produceInfo.isProducer ==1">
                    <i class="pro_tag" v-if="produceInfo.tagStatus == 3"></i>
                    <i class="pro_auth" v-if="produceInfo.isProducer == 1"></i>
                  </li>
                  <li v-if="produceInfo.producerType == 2&&produceInfo.isProducer ==1">
                    <span>团队</span>
                    <span>{{produceInfo.teamSize|teamSize}}</span>
                  </li>
                  <li v-if="produceInfo.producerType == 1&&produceInfo.isProducer ==1" class="personal">
                    <span>个人</span>
                    <span v-if="produceInfo.gender == 1">男</span>
                    <span v-if="produceInfo.gender == 2">女</span>
                  </li>
                </ul>
                <div class="buttons r" v-if="isme" style="position: relative;">
                  <button class="btn btn-empty" @click="onTagReal()" v-if="produceInfo.tagStatus == 0"><i class="icon"></i>标签认证</button>
                  <button class="btn btn-empty border-blue" @click="onTagReal()" v-if="produceInfo.tagStatus == 1"><i class="icon shenhe2"></i>认证中</button>
                  <button class="btn btn-empty border-red" @click="onTagReal()" v-if="produceInfo.tagStatus == 2"><i class="icon shenhe2"></i>认证失败</button>
                  <button class="btn btn-empty bg-blue" @click="onTagReal()" v-if="produceInfo.tagStatus == 3"><i class="icon shenhe2"></i>认证标签</button>

                  <button class="btn btn-empty" v-if="userInfo.isProducer == 0" @click="onProducerReal()"><i class="icon"></i>制作人认证</button>
                  <button class="btn bg-yellow" v-if="userInfo.isProducer == 1" @click="onProducerReal()"><i class="icon"></i>已认证</button>
                  <button class="btn bg-orange" v-if="userInfo.isProducer == 2" @click="onProducerReal()"><i class="icon"></i>认证审核中</button>
                  <button class="btn bg-red" v-if="userInfo.isProducer == 3" @click="onProducerReal()"><i class="icon"></i>认证失败</button>

                  <div v-if="produceAuthMsg" style="position: absolute; right: 0; bottom: -35px; width: 200px; color: #FF4C4C">*未满3个月不可以重新进行认证</div>
                </div>
                <div class="keep" v-else>
                  <button class="btn btn-empty btn-collect r" v-if="!produceInfo.isKeep" @click="onKeep"><i></i>收藏</button>
                  <button class="btn btn-empty btn-collect r ed" v-if="produceInfo.isKeep" @click="onKeep"><i></i>已收藏</button>
                </div>
              </div>
              <div class="vitae-tag">
                <span>{{produceInfo.tagStr}}</span>
              </div>
              <div class="vitae-foot">
                <div>
                  <label>所在城市</label>{{produceInfo.city&&produceInfo.isProducer ==1?produceInfo.city:"尚未编辑"}}
                  <label>从业年份</label>{{produceInfo.joinDate&&produceInfo.isProducer ==1?produceInfo.joinDate:"尚未编辑"}}
                </div>
                <div>
                  <label>擅长类型</label>{{produceInfo.skillStr&&produceInfo.isProducer ==1?produceInfo.skillStr:"尚未编辑"}}
                </div>
                <div>
                  <label>职业角色</label>{{produceInfo.roleStr&&produceInfo.isProducer ==1?produceInfo.roleStr:"尚未编辑"}}
                </div>
                <div>
                  <label>{{produceInfo.summary&&produceInfo.isProducer ==1?produceInfo.summary:"此人很懒，暂无相关介绍~"}}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="tabsbar clearfix">
            <div class="tabs l">
              <span class="tab" :class="{on: currTab == 1}" @click="onTabPanel(1)">作品集</span>
              <span class="tab" :class="{on: currTab == 2}" @click="onTabPanel(2)">场地库</span>
              <span class="tab" :class="{on: currTab == 3}" @click="onTabPanel(3)">器材库</span>
              <span class="tab" :class="{on: currTab == 4}" @click="onTabPanel(4)" v-if="isme">认证信息</span>
              <span class="tab" :class="{on: currTab == 5}" @click="onTabPanel(5)" v-if="isme && userInfo.isProducer == 1">服务协议</span>
            </div>
            <div class="opera r" v-show="currTab < 4">
              <div class="search">
                <input type="text" :placeholder="searchText" v-model="searchVal" maxlength="20"/><a class="" @click="onSearch"></a>
              </div>
              <button class="btn btn-default pub" v-if="isme && currTab == 1" @click="toPublish()"><i class="icon"></i>发布作品</button>
              <button class="btn btn-default pub" v-if="isme && currTab == 2" @click="toPublishVenue()"><i class="icon"></i>发布场地</button>
              <button class="btn btn-default pub" v-if="isme && currTab == 3" @click="toPublishEquipment()"><i class="icon"></i>发布器材</button>
            </div>
          </div>

          <div class="tab-panel">
            <div>
              <div class="empty" v-show="defaultPanel.panel5">
                <img src="../../assets/images/546.png">
                <p>没有搜索到相关内容，换个关键词试试</p>
              </div>

              <div class="empty" v-show="defaultPanel.panel1 && currTab == 1 && !defaultPanel.panel5">
                <img src="../../assets/images/547.png">
                <div v-if="!isme">
                  <p class="etitle">这个人太低调了，还没有发布作品</p>
                  <p>去看看其他内容吧～</p>
                </div>
                <div v-if="isme">
                  <p class="etitle">您还没有上传作品哦～</p>
                  <p>你若您有作品可用于展示，可发布作品，提升接单率</p>
                </div>
              </div>

              <div class="empty" v-show="defaultPanel.panel2 && currTab == 2 && !defaultPanel.panel5">
                <img src="../../assets/images/543.png">
                <div v-if="!isme">
                  <p class="etitle">这个人太低调了，还没有发布场地</p>
                  <p>去看看其他内容吧～</p>
                </div>
                <div v-if="isme">
                  <p class="etitle">您还没有发布场地信息哦～</p>
                  <p>若您有场地可用于出租，可发布场地，若拍摄有租用需求会与您联系</p>
                </div>
              </div>

              <div class="empty" v-show="defaultPanel.panel3 && currTab == 3 && !defaultPanel.panel5">
                <img src="../../assets/images/544.png">
                <div v-if="!isme">
                  <p class="etitle">这个人太低调了，还没有发布器材</p>
                  <p>去看看其他内容吧～</p>
                </div>
                <div v-if="isme">
                  <p class="etitle">您还没有发布器材信息哦～</p>
                  <p>若您有器材可用于出租，可发布器材，若拍摄有租用需求会与您联系</p>
                </div>
              </div>

              <div class="toauth" v-show="defaultPanel.panel4 && currTab == 4">
                <div class="toauth-producer">
                  <p>您还未进行制作人资质认证，认证后可在平台展示作品及接单</p>
                  <div><button class="btn btn-default" @click="onProducerReal()">请前往认证</button></div>
                </div>
                <div class="toauth-tag">
                  <p>您未进行制作人标签，如有需要可前往认证</p>
                  <div><button class="btn btn-default" @click="onTagReal()">认证标签</button></div>
                </div>
              </div>
            </div>

            <div class="panel" v-show="currTab == 1 && (produceList.length || this.topProduce)">
              <div class="topping clearfix" v-if="this.topProduce" v-show="!searchVal">
                <div class="img l">
                  <a :href="'caseDe.html?id='+topProduce.id">
                    <img :src="topProduce.coverUrl"/>
                  </a>
                  <span class="length">{{topProduce.videoLength}}</span>
                </div>
                <div class="info-box r">
                  <div class="info">
                    <div class="h2">{{topProduce.title}}</div>
                    <div class="date"><span class="ident" v-if="isme"><i class="icon"></i>置顶作品</span>发布时间：{{topProduce.addTime|formatDate}}</div>
                    <ul class="tag clearfix">
                      <li v-for="ys in topProduce.typeStr"><span>{{ys}}</span></li>
                    </ul>
                    <div class="summary">{{topProduce.description}}</div>
                  </div>

                  <div class="opera" v-if="isme&&topProduce.checkStatus != 0">
                    <a :href="'publication.html?edit='+topProduce.id" class="edit">编辑</a>
                    <a @click="del(topProduce)" class="delete">删除</a>
                  </div>
                </div>
              </div>

              <div class="list clearfix">
                <div class="case l" v-for="item in produceList" >
                  <div class="imgbox">
                    <a :href="'caseDe.html?id='+item.id" target="_blank">
                      <div class="img">
                        <img :src="item.coverUrl"/>
                        <span class="length">{{item.videoLength}}</span>
                      </div>
                      <div class="bg summary" v-if="item.checkStatus == 1">
                        <p>{{item.description}}</p>
                      </div>
                    </a>
                    <div class="bg state" v-if="item.checkStatus != 1">
                      <p class="audit" v-if="item.checkStatus == 0"><i class="icon"></i>审核中</p>
                      <p class="fail" v-if="item.checkStatus == 2"><i class="icon"></i>审核失败</p>
                      <p v-if="item.checkStatus == 2" style="padding: 0 35px; margin-top: 15px; font-size: 12px;">{{item.checkMsg}}</p>
                    </div>
                  </div>

                  <div class="info-box">
                    <div class="info">
                      <div class="h3">{{item.title}}</div>
                      <ul class="tag clearfix">
                        <li class="l" v-for="(ys,index) in item.typeStr" v-if="index<3"><span>{{ys}}</span></li>
                      </ul>
                    </div>

                    <div class="date">
                      <span>{{item.addTime|formatDate}}</span>
                      <div class="opera r" v-if="isme&&item.checkStatus != 0">
                        <a @click="getTop(item.id)" v-if="item.checkStatus == 1">置顶</a>
                        <a :href="'publication.html?edit='+item.id">编辑</a>
                        <a class="delete" @click="del(item)">删除</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pages" v-if="totalPage/pageSize>1">
                <Page :total="totalPage" :page-size="pageSize" @on-change="onPageChange" :current="currPage"></Page>
              </div>
            </div>

            <div v-show="currTab == 2 && venueList.length">
              <div class="list clearfix">
                <div class="case l" v-for="item in venueList" >
                  <div class="imgbox">
                    <a :href="'venueDetails.html?id='+item.id+'&type=1'" target="_blank">
                      <div class="img">
                        <img :src="item.cover"/>
                      </div>
                    </a>
                    <div class="bg state" v-if="item.checkStatus != 1">
                      <p class="audit" v-if="item.checkStatus == 0"><i class="icon"></i>审核中</p>
                      <p class="fail" v-if="item.checkStatus == 2"><i class="icon"></i>审核失败</p>
                      <p v-if="item.checkStatus == 2" style="padding: 0 35px; margin-top: 15px; font-size: 12px;">{{item.checkMsg}}</p>
                    </div>
                  </div>

                  <div class="info-box">
                    <div class="info">
                      <div class="h3"><a :href="'venueDetails.html?id='+item.id+'&type=1'" target="_blank">{{item.name}}</a></div>
                      <div class="tag">
                        <span>{{item.location | venueLocal}}</span>
                        <span>{{item.area}}m&sup2;</span>
                        <span>{{item.typeStr}}</span>
                        <span>{{item.purposeStr}}</span>
                      </div>
                    </div>

                    <div class="date">
                      <span>{{item.addTime|formatDate}}</span>
                      <div class="opera r" v-if="isme">
                        <a :href="'publishVenue.html?id='+item.id">编辑</a>
                        <a class="delete" @click="delVenue(item)">删除</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pages" v-if="totalPage/pageSize>1">
                <Page :total="totalPage" :page-size="pageSize" @on-change="onPageChange" :current="currPage"></Page>
              </div>
            </div>

            <div v-show="currTab == 3 && equipmentList.length">
              <div class="list clearfix">
                <div class="case l" v-for="item in equipmentList" >
                  <div class="imgbox">
                    <a :href="'venueDetails.html?id='+item.id+'&type=2'" target="_blank">
                      <div class="img">
                        <img :src="item.cover"/>
                      </div>
                    </a>
                    <div class="bg state" v-if="item.checkStatus != 1">
                      <p class="audit" v-if="item.checkStatus == 0"><i class="icon"></i>审核中</p>
                      <p class="fail" v-if="item.checkStatus == 2"><i class="icon"></i>审核失败</p>
                      <p v-if="item.checkStatus == 2" style="padding: 0 35px; margin-top: 15px; font-size: 12px;">{{item.checkMsg}}</p>
                    </div>
                  </div>

                  <div class="info-box">
                    <div class="info">
                      <div class="h3"><a :href="'venueDetails.html?id='+item.id+'&type=2'" target="_blank">{{item.name}}</a></div>
                    </div>

                    <div class="date">
                      <span>{{item.addTime|formatDate}}</span>
                      <div class="opera r" v-if="isme">
                        <a :href="'publishEquipment.html?id='+item.id">编辑</a>
                        <a class="delete" @click="delEquipment(item)">删除</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pages" v-if="totalPage/pageSize>1">
                <Page :total="totalPage" :page-size="pageSize" @on-change="onPageChange" :current="currPage"></Page>
              </div>
            </div>

            <div v-show="currTab == 4 && userInfo.isProducer">
              <div class="pane-accinfo">
                <div class="head">
                  <span>制作人资质认证</span>
                  <div class="buttons r" v-if="isme" style="position: relative;">
                    <button class="btn btn-empty" v-if="userInfo.isProducer == 0" @click="onProducerReal()"><i class="icon"></i>制作人认证</button>
                    <button class="btn bg-yellow" v-if="userInfo.isProducer == 1" @click="onProducerReal()"><i class="icon"></i>已认证</button>
                    <button class="btn bg-orange" v-if="userInfo.isProducer == 2" @click="onProducerReal()"><i class="icon"></i>认证审核中</button>
                    <button class="btn bg-red" v-if="userInfo.isProducer == 3" @click="onProducerReal()"><i class="icon"></i>认证失败</button>
                  </div>
                </div>
                <div class="cont clearfix">
                  <div class="l">
                    <div class="cell">
                      <span>类型：</span>
                      <span>{{authInfo.producerType == 1?'个人':'团队'}}</span>
                    </div>

                    <div class="cell">
                      <span v-if="authInfo.producerType == 1">真实姓名：</span>
                      <span v-if="authInfo.producerType == 2">公司名称：</span>
                      <span>{{authInfo.producerName}}</span>
                    </div>

                    <div class="cell" v-if="authInfo.producerType == 1">
                      <span>性别：</span>
                      <span v-if="authInfo.gender == 0">其他</span>
                      <span v-if="authInfo.gender == 1">男</span>
                      <span v-if="authInfo.gender == 2">女</span>
                    </div>

                    <div class="cell" v-if="authInfo.producerType == 2">
                      <span>团队规模：</span>
                      <span>{{authInfo.teamSize|teamSize}}</span>
                    </div>

                    <div class="cell">
                      <span>所在城市：</span>
                      <span>{{authInfo.city}}</span>
                    </div>

                    <div class="cell">
                      <span>职业角色：</span>
                      <span>
                        <div v-for="item in authInfo.cacheRole">
                          <span>{{item.role}}</span>
                          <span v-show="item.price">{{item.price}}/天</span>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div class="r">
                    <div class="cell">
                      <span>从业年份：</span><span>{{authInfo.joinDate}}年</span>
                    </div>

                    <div class="cell">
                      <span>擅长业务：</span><span><span v-for="item in authInfo.cacheSkill">{{item}}&nbsp;&nbsp;</span></span>
                    </div>

                    <div class="cell">
                      <span>简介：</span><span>{{authInfo.summary}}</span>
                    </div>

                    <div class="cell" v-if="authInfo.producerType == 2">
                      <span>联系人姓名：</span><span>{{authInfo.contactPerson}}</span>
                    </div>

                    <div class="cell" v-if="authInfo.producerType == 2">
                      <span>联系人手机号：</span><span>{{authInfo.contactNo}}</span>
                    </div>
                  </div>
                </div>
                <div class="head">
                  <span>制作人标签认证</span>
                  <div class="buttons r" v-if="isme" style="position: relative;">
                    <button class="btn btn-empty" @click="onTagReal()" v-if="produceInfo.tagStatus == 0"><i class="icon"></i>标签认证</button>
                    <button class="btn btn-empty border-blue" @click="onTagReal()" v-if="produceInfo.tagStatus == 1"><i class="icon shenhe2"></i>认证中</button>
                    <button class="btn btn-empty border-red" @click="onTagReal()" v-if="produceInfo.tagStatus == 2"><i class="icon shenhe2"></i>认证失败</button>
                    <button class="btn btn-empty bg-blue" @click="onTagReal()" v-if="produceInfo.tagStatus == 3"><i class="icon shenhe2"></i>认证标签</button>
                  </div>
                </div>
                <div class="cont clearfix">
                  <div class="cell"><span>已认证标签：</span><span>{{produceInfo.tagStr}}</span></div>
                  <div class="cell"><span>待审核标签：</span><span><span v-for="item in tagList" v-if="item.apply" style="margin-right: 5px;">{{item.name}}</span></span></div>
                </div>
              </div>
            </div>

            <div v-show="currTab == 5">
              <div class="protocol">
                <div class="text">在平台接单需签署相关服务协议，请扫描下方二维码前往签署，<br/>若您已签署，也可通过下方二维码进行查询。</div>
                <div class="qrimg"><img src="../../assets/images/qr3.png"></div>
                <div class="opera">
                  <button class="btn btn-empty" v-show="gmSignStatus == 0">未签署</button>
                  <button class="btn" v-show="gmSignStatus == 1">已签署</button>
                  <button class="btn btn-red" v-show="gmSignStatus == 2">已过期</button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


    <Modal v-model="modal" title="更换背景" width="800">
      <div style="padding: 60px 50px; text-align:center">
        <div id="bg" style="position: relative; overflow: hidden; height: 115px; line-height: 115px;">
          <img :src="newbg" style=" width: 100%;"/>
          <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; color: #ffffff; font-size: 16px; background: rgba(0,0,0,.4)">
            <span style="">上传背景图</span>
          </div>
        </div>
        <p style="margin-top: 20px; color: #B8B8B8; font-size: 12px;">请上传格式为jpg、jpeg、png的文件，大小不超过3M。建议尺寸1920*320px、960*160px。</p>
      </div>
      <div slot="footer" style="padding: 30px 0; text-align: center;">
        <Button class="btn btn-default" style="width: 150px; height: 40px; font-size: 16px; color: #ffffff;" long :loading="modal_loading" @click="ok">确定</Button>
      </div>
    </Modal>

    <Modal v-model="ModalDelete.state" title="提示" class="model" width="480" footer-hide>
      <div style="padding-bottom: 30px; font-size: 18px; text-align:center;">
        <div style="margin-top: 38px;" v-show="ModalDelete.curr == 1">确定删除当前作品吗？</div>
        <div style="margin-top: 38px;" v-show="ModalDelete.curr == 2">确定删除当前场地吗？</div>
        <div style="margin-top: 38px;" v-show="ModalDelete.curr == 3">确定删除当前器材吗？</div>
        <div style="margin-top: 30px;">
          <Button class="btn btn-default" @click="ModalDeleteBtn()">确定</Button>
        </div>
      </div>
    </Modal>

    <Modal v-model="ModalTag" title="身份标签认证" class="model modal-tagreal" width="590" footer-hide>
      <div style="padding: 4px; font-size: 14px;">
        <div>
          <dl class="clearfix">
            <dt>选择标签</dt>
            <dd class="sel">
              <span class="btn btn-empty" :class="{'active': item.apply,'on': item.current}" v-for="item in tagList" @click="onTagSel(item)">{{item.name}}</span>
            </dd>
          </dl>

          <dl class="clearfix">
            <dt>证明文件</dt>
            <dd>
              <div class="upl" style="margin-bottom: 15px;"><button class="btn btn-empty" id="tag">上传文件</button></div>
              <div>
                <div class="file" v-for="file,index in tagFileList">
                  <img src="../../assets/images/va.png"/>
                  <a :href="file" class="name" target="_blank"><span>证明文件{{index+1}}</span></a>
                  <a class="r del" href="javascript:;" @click="onDelTag(index)">删除</a>
                </div>
              </div>
            </dd>
          </dl>
        </div>
        <div style="padding: 50px 0 80px; text-align: center;">
          <Button class="btn btn-default" @click="onSubmitTagReal()" style="width: 280px;">提交审核</Button>
        </div>
      </div>
    </Modal>

    <Footer></Footer>
  </div>
</template>

<script>
  import '@/assets/js/common'
  import Header from  '@/components/Header'
  import Footer from  '@/components/Footer'
  import { userPageApi,caseIndex,accountApi,realApi,EquipmentApi,VenueApi } from '@/fetch/api'
  import util from '@/util/util'
  import dict from '@/util/dict'

  export default {
    components:{
      Header,Footer
    },
    data(){
      return{
        pageSize: 9, //每页条数
        totalPage: 0,  //总页数
        currPage: 1, //当前页数
        userInfo: "",
        produceList:[],
        topProduce: "",
        produceInfo: {},
        id: "",
        isme: 0, //0不是  1是
        modal: false,
        modal_loading: false,
        newbg: "https://qvbian-app.oss-cn-hangzhou.aliyuncs.com/sd/videoPhoto/r1531293218109K.png",
        ModalDelete: {
          state: false,
          id: "",
          curr: 0
        },
        ModalTag: false,
        tagList:[],
        tagFileList:[],
        applyId:0,
        produceAuthMsg: false,

        //5.3
        currTab: 1,
        searchVal: "",
        searchText: "搜索作品",
        authInfo: "",
        equipmentList: [],
        venueList: [],
        dictRole: dict.role,
        dictSkill: dict.business,
        defaultPanel:{
          panel1:false,
          panel2:false,
          panel3:false,
          panel4:false,
          panel5:false,
        },
        gmSignStatus: 0
      }
    },
    mounted(){
      this.id = util.GetQueryString("id");

      let user  = localStorage.getItem('userInfo');
      if(user){
        this.getDetail();
        this.getAuth();
        this.getTagList();
      }
      this.getProducerInfo();
      this.getTopProducer();

      $(document).ready(() => {
        util.ImgUpload("bg",(img)=>{
          this.newbg = img;
        });
        util.fileUpload("tag",(re)=>{
          this.tagFileList.push(re);
        });
      });
    },
    watch:{
      searchVal(newval, oldval){
        this.onSearch();
      }
    },
    methods:{
      //5.3
      delVenue(val){
        this.ModalDelete.state = true;
        this.ModalDelete.id = val.id;
        this.ModalDelete.curr = 2;
      },
      delEquipment(val){
        this.ModalDelete.state = true;
        this.ModalDelete.id = val.id;
        this.ModalDelete.curr = 3;
      },
      getDictRole(role){
        for(let item of this.dictRole){
          if(role == item.value){
            return item.name
          }
        }
      },
      getDictSkill(skill){
        for(let item of this.dictSkill){
          if(skill == item.value){
            return item.name
          }
        }
      },
      onSearch(){
        if(this.currTab == 1){
          this.getProducerWorks();
        } else if(this.currTab == 2){
          this.getVenue();
        } else {
          this.getEquipment();
        }
      },
      getAuth(){
        realApi.getProducerAuth().then((re) => {
          if(!re.status){
            msgError(re.message)
            return;
          }
          re.data.cacheRole = [];
          let role = re.data.role.split(",");
          let fee = re.data.fee.split(",");
          role.forEach((item,index)=>{
            let dr = this.getDictRole(item);
            re.data.cacheRole.push({role: dr, price: fee[index]});
          });

          re.data.cacheSkill = []
          let skill = re.data.skillfullType?re.data.skillfullType.split(","):[];
          skill.forEach((item,i)=>{
            let ds = this.getDictSkill(item);
            re.data.cacheSkill.push(ds);
          });

          this.authInfo = re.data;
        });
      },
      onTabPanel(val){
        this.currTab = val;
        this.currPage = 1;
        this.searchVal = "";
        this.defaultPanel.panel5 = false;
        if(val == 1){
          this.searchText = "搜索作品";
          this.getTopProducer();
        } else if(val == 2){
          this.searchText = "搜索场地";
          this.getVenue();
        } else if(val == 3){
          this.searchText = "搜索器材";
          this.getEquipment();
        } else if(val == 4){
          if(this.userInfo.isProducer == 0){
            this.defaultPanel.panel4 = true;
          }
        }
      },
      getVenue(){
        let params = {
          "accountId": this.id,
          "name": this.searchVal,
          "pageNo": this.currPage,
          "pageSize": this.pageSize
        }

        VenueApi.getVenueByPage(params).then((re) => {
          if(!re.status){
            alert(re.message);
            return;
          }
          if(!re.list.length && !this.searchVal){
            this.defaultPanel.panel2 = true;
          }
          if(!re.list.length && this.searchVal){
            this.defaultPanel.panel5 = true;
          } else {
            this.defaultPanel.panel5 = false;
          }
          this.venueList = re.list;
          this.totalPage = re.counts;
        });
      },
      getEquipment(){
        let params = {
          "accountId": this.id,
          "name": this.searchVal,
          "pageNo": this.currPage,
          "pageSize": this.pageSize
        }

        EquipmentApi.getEquipmentByPage(params).then((re) => {
          if(!re.status){
            alert(re.message);
            return;
          }
          if(!re.list.length && !this.searchVal){
            this.defaultPanel.panel3 = true;
          }
          if(!re.list.length && this.searchVal){
            this.defaultPanel.panel5 = true;
          } else {
            this.defaultPanel.panel5 = false;
          }
          this.equipmentList = re.list;
          this.totalPage = re.counts;
        });
      },
      //5.3

      onSubmitTagReal(){
        let list = [];
        this.tagList.forEach((item)=>{
          if(item.apply == 1){
            list.push(item.id);
          }
        });

        if(list.length == 0){
          msgError("请选择标签");
          return;
        }

        if(this.tagFileList.length==0){
          msgError("请上传证明文件");
          return;
        }

        let params = {
          "id": this.applyId,
          "accountId": this.id,
          "applyFile": this.tagFileList.toString().replace(",",";"),
          "applyTag": list.toString()
        }

        userPageApi.postProducerTagAuth(params).then((re) => {
          msgSuccess("提交成功！");
          this.ModalTag=false;
          location.reload();
        });
      },
      onTagSel(item){
        if(item.current == 1){
          return;
        }

        item.apply = item.apply?0:1;
      },
      onDelTag(val){
        this.tagFileList.splice(val,1);
      },
      toPublish(){
        if(this.userInfo.isProducer == 1){
          location.href = 'publication.html?id='+this.id;
        } else {
          msgError("只有认证制作人可以发布作品，你还不是制作人，请先认证。")
        }
      },
      toPublishVenue(){
        if(this.userInfo.isProducer == 1){
          location.href = 'publishVenue.html';
        } else {
          msgError("只有认证制作人可以发布作品，你还不是制作人，请先认证。")
        }
      },
      toPublishEquipment(){
        if(this.userInfo.isProducer == 1){
          location.href = 'publishEquipment.html';
        } else {
          msgError("只有认证制作人可以发布作品，你还不是制作人，请先认证。")
        }
      },
      onTagReal(){
        this.getTagList();
        this.ModalTag=true;
      },
      getTagList(){
        userPageApi.getProducerTagAuth({}).then((re) => {

          if(re.data.producerTagApply){
            re.data.applyTag = re.data.producerTagApply.applyTag.split(",");
            this.tagFileList = re.data.producerTagApply.applyFile.split(";");
            this.applyId = re.data.producerTagApply.id;
          }


          re.data.tagList.forEach((a)=>{
            a.apply = 0;
            a.current = 0;

            if(re.data.producerTagApply){
              re.data.applyTag.forEach((b)=>{
                if(a.id == b){
                  a.apply = 1;
                }
              });
            }

            if(re.data.currentList){
              re.data.currentList.forEach((c)=>{
                if(a.id == c.tagId){
                  a.current = 1;
                }
              });
            }
          });

          this.tagList = re.data.tagList;
        });
      },
      onProducerReal(){
        if(this.userInfo.producerAuthTime && this.userInfo.isProducer == 1 && (new Date().getTime() - this.userInfo.producerAuthTime)<7776000000){
          this.produceAuthMsg = true;
        } else {
          if(this.userInfo.isProducer == 0){
            location.href = 'realSingleInfo.html?id='+this.id+'&isProducer=0';
          } else if((this.userInfo.isProducer == 3 || this.userInfo.isProducer == 1) && this.userInfo.producerType ==1){
            location.href = 'realSingleInfo.html?id='+this.id+'&isProducer=3';
          } else if((this.userInfo.isProducer == 3 || this.userInfo.isProducer == 1) && this.userInfo.producerType ==2){
            location.href = 'realTeamInfo.html?id='+this.id+'&isProducer=3';
          } else if((this.userInfo.isProducer == 3 || this.userInfo.isProducer == 1) && this.userInfo.producerType ==3){
            location.href = 'realActorInfo.html?id='+this.id+'&isProducer=3';
          }
        }

      },
      onKeep(){
          let params = {
            "type": this.produceInfo.isKeep?2:1,
            "producerId": this.produceInfo.id
          }

          userPageApi.apiAccountProducerKeep(params).then((re) => {
            if(this.produceInfo.isKeep){
              msgSuccess("取消成功")
              this.produceInfo.isKeep = 0;
            } else {
              msgSuccess("收藏成功")
              this.produceInfo.isKeep = 1;
            }
          });
      },
      getDetail(){
        accountApi.apiAccountGetDetail().then(data=>{
          if(data.data.id == this.id){
            this.isme = 1;
          }
          if(data.data.producerType == 3 && this.isme == 1){
            window.location.href = 'talentActor.html?id='+this.id+'&origin=1';
            return;
          }
          this.userInfo = data.data;
          this.gmSignStatus = data.gmSignStatus;
        });
      },
      ok() {
        let params = {
          "backgroundUrl": this.newbg
        };

        this.modal_loading = true;
        userPageApi.accountangeBackground(params).then((re) => {
          if(!re.status){
            this.$Message.success(re.message);
            return;
          }

          this.modal_loading = false;
          this.modal = false;
          this.$Message.success('上传成功');
        });
      },
      onPageChange(no){
        this.currPage = no;
        if(this.currTab == 1){
          this.getProducerWorks();
        } else if(this.currTab == 2){
          this.getVenue();
        } else if(this.currTab == 3){
          this.getEquipment();
        }
      },
      getProducerInfo(){
        let params = {
          "accountId": this.id
        };

        userPageApi.getProducerDetail(params).then((re) => {
          if(!re.status){
            alert(re.message);
            return;
          }
          if(re.data.backgroundUrl){
            this.newbg = re.data.backgroundUrl;
          }
          if(re.data.tagStr){
            re.data.tagStr = re.data.tagStr.replace(/,/g,"  ")
          }
          // if(re.data.producerType == 3){
          //   window.location.href = 'talentActor.html?id='+this.id+'&origin=2';
          //   return;
          // }
          this.produceInfo = re.data;
        });
      },
      getProducerWorks(){
        let params = {
          "accountId": this.id,
          "name": this.searchVal,
          "pageNo": this.currPage,
          "pageSize": this.pageSize
        }
        // this.$Spin.show();
        caseIndex.getWorkSampleByPage(params).then((re) => {
          if(!re.status){
            alert(re.message);
            return;
          }
          // this.$Spin.hide();
          if(re.list){
            re.list.forEach((item)=>{
              item.typeStr = item.typeStr.split(",");
            });
          }
          if(!re.list.length && !this.topProduce){
            this.defaultPanel.panel1 = true;
          }
          if(!re.list.length && this.searchVal){
            this.defaultPanel.panel5 = true;
          } else {
            this.defaultPanel.panel5 = false;
          }
          this.produceList = re.list;
          this.totalPage = re.counts;
        });
      },
      getTopProducer(){
        let params = {
          "accountId": this.id
        };

        userPageApi.getTopSample(params).then((re) => {
          if(!re.status){
            alert(re.message);
            return;
          }
          if(re.data){
            re.data.typeStr = re.data.typeStr.split(",");
          }
          this.topProduce = re.data;
          this.getProducerWorks();
        });
      },
      ModalDeleteBtn(){
        if(this.ModalDelete.curr == 1){
          userPageApi.apiAccountDeleteWorkSample({id:this.ModalDelete.id}).then(data=>{
            if(data.status === 1){
              this.ModalDelete.state = false;
              this.ModalDelete.curr = 0;
              msgSuccess('删除成功！');
              this.getTopProducer();
            }
          });
        } else if(this.ModalDelete.curr == 2){
          VenueApi.deleteVenue({id:this.ModalDelete.id}).then(data=>{
            if(data.status === 1){
              this.ModalDelete.state = false;
              this.ModalDelete.curr = 0;
              msgSuccess('删除成功！');
              this.getVenue();
            }
          });
        } else {
          EquipmentApi.deleteEquipment({id:this.ModalDelete.id}).then(data=>{
            if(data.status === 1){
              this.ModalDelete.state = false;
              this.ModalDelete.curr = 0;
              msgSuccess('删除成功！');
              this.getEquipment()
            }
          });
        }

      },
      del(val){
        this.ModalDelete.state = true;
        this.ModalDelete.id = val.id;
        this.ModalDelete.curr = 1;
      },
      getTop(id){
        userPageApi.apiAccountSetTopWorkSample({id:id}).then(data=>{
          if(data.status === 1){
            // msgSuccess('置顶成功！');
            location.reload();
          }else{
            msgError(data.message)
          }
        });
      }
    }
  }
</script>

<style scoped>
  .main{
    padding-bottom: 120px;
  }
  .tab-panel{
    padding-top: 30px;
    min-height: 500px;
  }

  .toauth{
    font-size: 18px;
    text-align: center;
    background: #ffffff;
  }
  .toauth>div{
    padding: 80px 0 100px;
  }
  .toauth>div:nth-child(1){
    border: 1px solid #F5F5F5;
  }
  .toauth p{
    margin-bottom: 30px;
  }
  .toauth .btn{
    font-size: 16px;
  }

  .pane-accinfo{
    background: #ffffff;
  }
  .pane-accinfo .head{
    padding: 18px 20px;
    border-bottom: 1px solid #F5F5F5;
  }
  .pane-accinfo .head span{
    font-size: 16px;
    font-weight: 600;
  }
  .pane-accinfo .head .buttons{
    margin-top: -3px;
  }
  .pane-accinfo .cont{
    padding: 20px;
  }
  .pane-accinfo .cont>div{
    width: 50%;
  }
  .cell {
    padding: 10px 0;
    line-height: 25px;
  }
  .cell>span:nth-child(1){
    display: inline-block;
    width: 112px;
    vertical-align: top;
  }
  .cell>span:nth-child(2){
    display: inline-block;
    width: 460px;
  }
  .cell>span>div>span:nth-child(1){
    display: inline-block;
    width: 102px;
  }

  .pagebg{
    height: 320px;
    background-repeat: no-repeat;
    background-size: 100% auto;
  }
  .pagebg .btn{
    margin-top: 30px;
    padding: 0;
    width: 90px;
    height: 30px;
    line-height: 30px;
    background: rgba(0,0,0,0.40);
    border-radius: 100px;
  }
  .pagebg .btn i{
    margin-top: -2px;
    width: 16px;
    height: 16px;
    vertical-align: middle;
    background-position: -635px -1236px;
  }

  .master-info{
    margin-top: -50px;
    padding: 20px;
    border-bottom: 1px solid #F5F5F5;
    background: #ffffff;
  }
  .master-mask{
    width: 200px;
    height: 200px;
    overflow: hidden;
  }
  .master-vitae{
    padding-left: 20px;
    width: 960px;
  }
  .master-vitae .vitae-head .name{
    float: left;
    font-size: 28px;
    color: #424753;
    font-weight: 600;
  }
  .master-vitae .vitae-head .tag{
    float: left;
    margin-top: 14px;
    margin-left: 20px;
  }
  .master-vitae .vitae-head .tag li{
    float: left;
    margin-right: 10px;
  }
  .master-vitae .vitae-head .tag li span{
    margin-right: 9px;
    padding: 3px 16px;
    font-size: 12px;
    color: #3E87FF;
    background: rgba(62,135,255,0.20);
    border-radius: 100px;
  }
  .master-vitae .vitae-head .tag li.personal span{
    color: #F5A623;
    background: rgba(255,191,0,0.20);
  }
  .master-vitae .vitae-head .tag li .pro_tag{
    display: inline-block;
    margin-right: 10px;
    width: 20px;
    height: 20px;
    background: url("../../assets/images/auth2.png") no-repeat scroll center;
  }
  .master-vitae .vitae-head .tag li .pro_auth{
    display: inline-block;
    width: 20px;
    height: 20px;
    background: url("../../assets/images/auth1.png") no-repeat scroll center;
  }
  .buttons .btn{
    padding: 0 7px;
    width: auto;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    vertical-align: top;
  }
  .buttons .btn-empty{
    color: #838895;
    border-color: #838895;
  }
  .master-vitae .buttons button:nth-child(1){
    margin-right: 16px;
  }
  .buttons .btn i{
    display: inline-block;
    margin-right: 5px;
    vertical-align: middle;
  }
  .buttons .real-producer i{
    margin-top: -3px;
    width: 18px;
    height: 14px;
    background-position: -670px -1209px;
  }
  .buttons .real-tag i{
    margin-top: -3px;
    width: 12px;
    height: 15px;
    background: url("../../assets/images/icon_tag1.png") no-repeat scroll center;
  }
  .buttons .bg-orange{
    color: #ffffff;
    background: #F5A623;
  }
  .buttons .bg-orange i{
    background-position: -695px -1304px;
  }
  .buttons .bg-red{
    color: #ffffff;
    background: #FF3535;
  }
  .buttons .bg-red i{
    background-position: -695px -1304px;
  }
  .buttons .bg-yellow{
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    color: #ffffff;
    background: #FFBF00;
  }
  .buttons .bg-yellow i{
    margin-right: 0px;
    width: 20px;
    height: 20px;
    background-position: -884px -948px;
  }
  .buttons .border-red{
    color: #FF4D4D;
    border-color: #FF4D4D;
  }
  .buttons .border-red i{
    background: url("../../assets/images/icon_tag4.png") no-repeat scroll center;
  }
  .buttons .border-blue{
    color: #00D0DA;
    border-color: #00D0DA;
  }
  .buttons .border-blue i{
    background: url("../../assets/images/icon_tag2.png") no-repeat scroll center;
  }
  .buttons .bg-blue{
    color: #ffffff;
    background: #00D0DA;
    border-color: #00D0DA;
  }
  .buttons .bg-blue i{
    background: url("../../assets/images/icon_tag3.png") no-repeat scroll center;
  }
  .keep .btn{
    padding: 6px 0;
    width: 85px;
  }
  .vitae-tag{
    margin-top: 5px;
  }
  .vitae-tag span{
    margin-right: 10px;
    font-size: 12px;
    color: #FF5555;
  }
  .vitae-foot div{
    margin-top: 10px;
    color: #424753;
  }
  .vitae-foot div label{
    margin-right: 15px;
    color: #424753;
    opacity: 0.6;
  }
  .vitae-foot div label:nth-child(2){
    margin-left: 30px;
  }

  .tabsbar{
    padding: 0 20px;
    font-size: 16px;
    background: #FFFFFF;
  }
  .tabsbar .tabs .tab{
    display: inline-block;
    margin-right: 60px;
    padding: 18px 0;
    cursor: pointer;
  }
  .tabsbar .tabs .tab.on{
    color: #3E87FF;
  }
  .tabsbar .opera{
    margin-top: 14px;
  }
  .search{
    display: inline-block;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
  }
  .search input{
    padding: 8px 10px;
    width: 223px;
    height: 33px;
    line-height: 33px;
    vertical-align: middle;
    border: 0;
    border-radius: 4px;
  }
  .search a{
    display: inline-block;
    width: 33px;
    height: 33px;
    vertical-align: middle;
    background: transparent url("../../assets/images/sousuo.png") no-repeat scroll center;
  }
  .pub{
    margin-left: 20px;
    padding: 0;
    width: 100px;
    height: 35px;
    line-height: 35px;
    box-shadow: 0 5px 20px 0 rgba(92,141,222,.4);
  }
  .pub .icon{
    margin-top: -3px;
    margin-right: 6px;
    width: 18px;
    height: 18px;
    background-position: -633px -1207px;
  }

  .topping{
    margin-bottom: 30px;
    background: #ffffff;
  }
  .topping a:hover{
    opacity: 1;
  }
  .topping .img{
    position: relative;
    width: 790px;
    height: 474px;
    overflow: hidden;
  }
  .topping .img img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .topping .img .length{
    position: absolute;
    right: 15px;
    bottom: 26px;
    color: #ffffff;
  }
  .topping .info-box{
    position: relative;
    padding: 30px;
    width: 410px;
    height: 474px;
  }
  .topping .info-box .date{
    margin-top: 15px;
    font-size: 12px;
    color: #424753;
  }
  .topping .info-box .date .ident{
    display: inline-block;
    margin-right: 14px;
    padding: 2px 4px;
    color: #ffffff;
    background: #FF3535;
    border-radius: 2px;
  }
  .topping .info-box .date .ident i{
    display: inline-block;
    margin-right: 3px;
    margin-top: -2px;
    width: 13px;
    height: 13px;
    vertical-align: middle;
    background-position: -673px -1238px;
  }
  .topping .info-box .tag{
    margin-top: 15px;
  }
  .topping .info-box .tag li{
    float: left;
  }
  .topping .info-box .tag li span{
    display: inline-block;
    margin-right: 5px;
    margin-bottom: 5px;
    padding: 3px 10px;
    color: #424753;
    background: #F0F0F0;
    border-radius: 2px;
  }
  .topping .info-box .summary{
    margin-top: 15px;
    max-height: 200px;
    line-height: 20px;
    font-size: 12px;
    color: #424753;
    opacity: 0.6;
    overflow: hidden;
  }
  .topping .info-box .opera{
    position: absolute;
    bottom: 30px;
  }
  .topping .info-box .opera .edit{
    margin-right: 15px;
    color: #424753;
  }
  .topping .info-box .opera .delete{
    color: #424753;
    opacity: .6;
  }

  .case{
    margin: 0 0 30px 30px;
    width: 380px;
    background: #FFFFFF;
    cursor: pointer;
  }
  .case:nth-child(3n+1){
    margin-left: 0px;
  }
  .case .imgbox{
    position: relative;
    height: 304px;
    overflow: hidden;
  }
  .panel .case .imgbox{
    height: 214px;
  }
  .case .imgbox img{
    width: 100%;
    height: 304px;
    object-fit: cover;
  }
  .panel .case .imgbox img{
    height: 214px;
  }
  .case .imgbox .img .length{
    position: absolute;
    right: 15px;
    bottom: 10px;
    color: #ffffff;
    z-index: 100;
  }
  .case .imgbox .bg{
    position: absolute;
    top: 0;
    padding: 15px;
    width: 100%;
    height: 100%;
    color: #ffffff;
    font-size: 12px;
    background: rgba(13,20,37,.6);
    border-radius: 2px;
  }
  .case .imgbox .summary{
    opacity: 0;
    transition: all .5s;
  }
  .case .imgbox .state{
    text-align: center;
    font-size: 14px;
    color: #FFFFFF;
  }
  .case .imgbox .state .audit{
    margin-top: 85px;
  }
  .case .imgbox .state .audit i{
    margin-right: 4px;
    width: 18px;
    height: 18px;
    background-position: -771px -1209px;
  }
  .case .imgbox .state .fail{
    margin-top: 46px;
  }
  .case .imgbox .state .fail i{
    margin-right: 4px;
    width: 18px;
    height: 18px;
    background-position: -771px -1209px;
  }
  .case .info-box .info{
    padding: 12px 15px;
    border-bottom: 1px solid #EFEFEF;
  }
  .case .info-box .info .h3{
    color: #424753;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .case .info-box .info .tag{
    margin-top: 6px;
    font-size: 12px;
    color: #5E6370;
  }
  .case .info-box .info ul.tag span{
    margin-right: 5px;
    display: inline-block;
    padding: 3px 10px;
    background: #F0F0F0;
    border-radius: 2px;
  }
  .case .info-box .info div.tag span{
    margin-right: 10px;
  }
  .case .info-box .date{
    padding: 17px 20px 17px 15px;
    color: #424753;
  }
  .case .info-box .date span{
    opacity: .6;
  }
  .case .info-box .date .opera a{
    margin-left: 10px; color: #424753;
  }
  .case .info-box .date .opera .delete{
    opacity: .6;
  }
  .case:hover .info-box .info .h3 a{
    color: #3E87FF;
  }
  .case:hover .imgbox .summary{
    opacity: 1;
  }

  .pages{
    padding: 30px;
    text-align: center;
  }

  .protocol{
    padding: 50px;
    text-align: center;
    background: #ffffff;
  }
  .protocol .text{
    margin-bottom: 30px;
    font-size: 16px;
    line-height: 29px;
  }
  .protocol .qrimg img{
    display: inline-block;
    width: 200px;
    height: 200px;
  }
  .protocol .opera{
    margin-top: 40px;
  }
  .protocol .opera .btn{
    padding: 0;
    width: 120px;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
  }
  .protocol .opera .btn-empty{
    color: #3E87FF;
    border-color: #3E87FF;
  }
  .protocol .opera .btn-red{
    background: #FF4D4D;
  }

  .empty{
    padding: 80px 0;
    text-align: center;
    background: #ffffff;
  }
  .empty .etitle{
    margin: 20px 0 10px;
    font-size: 20px;
    font-weight: 600;
  }
</style>
<style>
  .modal-tagreal dl{ margin-bottom: 20px;}
  .modal-tagreal dl dt{ float: left; width: 64px;}
  .modal-tagreal dl dd{ float: left; padding-left: 30px; width: 486px;}
  .modal-tagreal .sel .btn{ margin-right: 8px; margin-bottom: 10px; padding: 3px 0; width: 100px; color: #555;}
  .modal-tagreal .sel .btn.active{ color: #ffffff; background: #3E87FF; border-color: #3E87FF; opacity: 1;}
  .modal-tagreal .sel .btn.on{ color: #B8B8B8; background: #f0f0f0; border-color: #D8D8D8; opacity: 1;}
  .modal-tagreal .upl .btn{ color: #3E87FF; border-color: #3E87FF;}
  .modal-tagreal .file{ margin-right: 20px; margin-bottom: 10px;}
  .modal-tagreal .file img{ display: inline-block; margin-right: 10px; width: 22px; height: 26px; vertical-align: bottom;}
  .modal-tagreal .file .name{ color: #424753;}
  .modal-tagreal .file .del{ color: #FF3535;}
</style>



// WEBPACK FOOTER //
// App.vue?a5d34edc